import { useQuery } from 'react-query';

type variantsType = { Sku: number; DisplayPriceInc: number; ProductGroupId?: number }[];

type useServiceSuggestionsProps = {
  variants: variantsType;
  shouldFetchServiceSuggestions: boolean;
  fetchServiceSuggestions: (variants: variantsType) => Promise<any>;
};

export const useServiceSuggestions = ({
  variants,
  shouldFetchServiceSuggestions,
  fetchServiceSuggestions,
}: useServiceSuggestionsProps) => {
  const { data, error, status } = useQuery({
    enabled: shouldFetchServiceSuggestions,
    queryKey: ['serviceSuggestions', variants],
    queryFn: () => fetchServiceSuggestions(variants),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
  const isLoading = status === 'loading';

  if (error) return { isLoading, serviceSuggestions: [], error };

  return { isLoading, serviceSuggestions: data, error };
};
